import React from 'react';
import {withTranslation} from 'react-i18next';
import {Button} from '@betareader/design-system';
import useAutoSaveContext, {SAVE_STATE} from '../../hooks/useAutoSaveContext';

export const ContentAutoSaveButton = ({t}) => {
  const {save, saveState} = useAutoSaveContext();
  const label = saveState === SAVE_STATE.save ? t('Save')
    : saveState === SAVE_STATE.saving ? t('Saving') : t('Saved');

  return (
    <Button
      variant={saveState === SAVE_STATE.save ? 'primary' : 'secondary'}
      disabled={saveState !== SAVE_STATE.save}
      aria-busy={saveState === SAVE_STATE.saving}
      onClick={save}
    >{label}</Button>
  );
};

export default withTranslation()(ContentAutoSaveButton);
